var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5104 10.9896C13.5846 10.0638 12.4827 9.37846 11.2804 8.96358C12.5681 8.07669 13.4141 6.59241 13.4141 4.91406C13.4141 2.20445 11.2096 0 8.5 0C5.79039 0 3.58594 2.20445 3.58594 4.91406C3.58594 6.59241 4.43192 8.07669 5.71964 8.96358C4.51735 9.37846 3.41541 10.0638 2.4896 10.9896C0.884166 12.595 0 14.7296 0 17H1.32812C1.32812 13.0454 4.54541 9.82812 8.5 9.82812C12.4546 9.82812 15.6719 13.0454 15.6719 17H17C17 14.7296 16.1158 12.595 14.5104 10.9896ZM8.5 8.5C6.52272 8.5 4.91406 6.89138 4.91406 4.91406C4.91406 2.93675 6.52272 1.32812 8.5 1.32812C10.4773 1.32812 12.0859 2.93675 12.0859 4.91406C12.0859 6.89138 10.4773 8.5 8.5 8.5Z",
    fill: "#0C2240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserForm);
export default __webpack_public_path__ + "static/media/userForm.c44fc2e3f2f387bae8735b6c69a73e54.svg";
export { ForwardRef as ReactComponent };